import React from 'react';
import { BoneIcon, LockIcon } from 'lucide-react';
import { CHECKOUT_URL, OFFER_ANCHOR, PRODUCT_PRICE } from '../data/config';
import { trackPixel } from '../utils/pixel';
type CtaButtonProps = {
  children: React.ReactNode;
  mode: 'checkout' | 'scroll';
  subtext?: string;
  className?: string;
};
export function CtaButton({
  children,
  mode,
  subtext,
  className = 'max-w-[448px]'
}: CtaButtonProps) {
  const isCheckout = mode === 'checkout';
  const Icon = isCheckout ? LockIcon : BoneIcon;
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={() => isCheckout && trackPixel('InitiateCheckout', {
    value: PRODUCT_PRICE,
    currency: 'USD'
  })} className={`mx-auto flex min-h-[50px] w-full flex-col items-center justify-center rounded-md bg-gold px-4 py-2.5 text-center text-navy shadow-cta transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-goldHover active:translate-y-[2px] active:shadow-cta-pressed focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 ${className}`} data-id="element-41" data-mp="lm8ukc2o4oe7">
      <span className="flex items-center gap-2 font-heading text-[15px] font-extrabold uppercase leading-tight md:text-[18px]" data-id="element-42" data-mp="35ziocjr7kesq">
        <Icon className="h-[18px] w-[18px] shrink-0" strokeWidth={2.75} aria-hidden data-id="element-43" data-mp="3exb2hkl71gej" />
        <span className="text-balance" data-id="element-44" data-mp="3jwnq47jw2ri6">{children}</span>
      </span>
      {subtext && <span className="mt-1 text-[11px] font-semibold leading-tight" data-id="element-45" data-mp="3jukqcvsxpk09">{subtext}</span>}
    </a>;
}